<template>
	<div>
		<organization-home />
	</div>
</template>

<script>
import Home from "./layout-components/organization-home"

export default {
	name: "OrganizationLayout",
	components: {
		"organization-home": Home
	}
}
</script>

<style scoped></style>
